module.exports = __webpack_public_path__ + "img/godwin-akpan-all-a-blur.096fedc.jpg";